const ApiConnect = () => (<h2>API Connect</h2>);

export default ApiConnect;
